function paramsToObject(urlSearchParams) {
    const result = {};
    for (const [key, value] of urlSearchParams.entries()) {
        result[key] = value;
    }
    return result;
}
// A custom hook that builds on useLocation to parse the query string for you.
function getURLParams() {
    const url = window.location.href.toString();
    const separatorChar = url.indexOf('#') >= 0 ? '#' : '?';
    if (url.includes(separatorChar)) {
        const searchParamsStr = url.substring(url.indexOf(separatorChar) + 1);
        const params = paramsToObject(new URLSearchParams(searchParamsStr));
        return params;
    }
    else {
        return {};
    }
}
// function generateCrossword(words) {
//   const across = [];
//   const down = [];
//   for (let i = 0; i <= words.length; i++) {
//     if (i === 0) {
//       across.push({
//         1: { hashedAnswer: words[i].hashedAnswer, clue: words[i].clue },
//       });
//     }
//   }
// }
async function calculateHash(word) {
    const encoder = new TextEncoder();
    const data = encoder.encode(word);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
    return hashHex;
}
export { getURLParams, calculateHash };
